<template>
<div class="chapter">
<div class="inner_page">
<p class="Ded"><a id="page_vii"><span class="small">PHILEMON</span></a></p><a id="page_vii">
<p class="Ded1">“Pastor, what do you think would have happened<br/>if a runaway slave in America<br/>had carried this letter back to his master?”</p>
<p class="Ded2">J<span class="small">AMES</span> A. N<span class="small">OEL</span></p>
<p class="Ded3">Onesimus Our Brother, 5</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?35806320